export const CATEGORY_COLORS: { [key: string]: string } = {
    'Self Reported Loyalty': '#1890ff',
    'Product Performance': '#52c41a',
    'Product Richness': '#faad14',
    'Brand Familiarity': '#eb2f96',
    'Symbolic Recall': '#722ed1',
    'Brand Valence': '#13c2c2',
    'Brand Trust': '#fa8c16',
    'Brand Empathy': '#a0d911',
    'Repurchase Intention': '#f5222d',
    'Parity Preference': '#1890ff',
    'Price Deals': '#52c41a',
    'Price': '#faad14',
    'Brand Environment': '#eb2f96',
    'Distribution Intensity': '#722ed1',
    'Availability': '#722ed1',
    'Advertising Intensity': '#13c2c2',
    'Advertising Content': '#fa8c16',
    'User Congruence': '#a0d911',
    'Brand Identification': '#f5222d',
    'Unique': '#87d068',
    'Staff Behaviour': '#ff85c0',
    'Self Congruence': '#ffc53d',
    'Perceived Value for the Cost': '#73d13d',
    'Brand Self Connection': '#40a9ff',
    'Prominence': '#b37feb',
    'Standardised NPS': '#2f54eb',
    'Advocacy Intent': '#2f54eb',
};

// Color palette for any new categories not in the list
export const COLOR_PALETTE = [
    '#1890ff', '#52c41a', '#faad14', '#eb2f96', '#722ed1',
    '#13c2c2', '#fa8c16', '#a0d911', '#f5222d', '#87d068',
    '#ff85c0', '#ffc53d', '#73d13d', '#40a9ff', '#b37feb'
];

export const getColorForCategory = (category: string, index?: number): string => {
    return CATEGORY_COLORS[category] || COLOR_PALETTE[(index || 0) % COLOR_PALETTE.length];
};